import { useQuery } from "@tanstack/react-query";
import { frappeMethod } from "@/lib/erp/utils";

interface ArchivedCountResult {
  count: number;
  has_disabled_field: boolean;
  disabled_field_name: string | null;
}

/**
 * Fetch the count of archived (disabled=1) documents for a doctype.
 * Used by ShowArchivedToggle to display the badge count.
 * staleTime=60s per user story Q3.
 */
export function useArchivedCount(doctype: string, enabled = true) {
  return useQuery({
    queryKey: ["archived-count", doctype],
    queryFn: () =>
      frappeMethod<ArchivedCountResult>(
        "zaviago_backend.api.archive.get_archived_count",
        { doctype },
      ),
    staleTime: 60_000,
    enabled,
  });
}
